// src/components/layout/PublicLayout.jsx
import React from 'react';
import { Outlet } from 'react-router-dom';
import PublicHeader from './PublicHeader';
import Footer from './Footer';

const PublicLayout = ({ user, avatarUrl, onLogout, authStateResolved }) => {
  return (
    <div className="min-h-screen flex flex-col bg-gray-50 safe-area-inset">
      <PublicHeader
        user={user}
        avatarUrl={avatarUrl}
        onLogout={onLogout}
        authStateResolved={authStateResolved}
      />

      {/* Main content area */}
      <main className="flex-grow">
        <Outlet />
      </main>

      {/* Footer at bottom */}
      <Footer />
    </div>
  );
};

export default PublicLayout;